<script lang="ts">
    import { Col, Nav, NavItem, NavLink} from "sveltestrap";
    import { Advance, Base, Forms, Rating, Scrollable, StaticSubNav, Tables, TreeView } from "../../../utils/Constant/Constant";
    import FeatherIcon from "svelte-feather-icon";
</script>
<Col lg="6">
    <div>
      <h5>{StaticSubNav}</h5>
    </div>
    <Nav vertical class="icon-lists border navs-icon">
        <NavItem>
            <NavLink ><FeatherIcon icon="box"/>
                <span> {Base}</span>
            </NavLink>
        </NavItem>
        <NavItem>
            <NavLink><FeatherIcon icon="folder-plus"/>
                <span> {Advance}</span>
            </NavLink>
            <Nav>
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i> {Scrollable}</NavLink>
                </NavItem>
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i>{TreeView}</NavLink>
                </NavItem>
                <NavItem class="pl-navs-inline">
                    <NavLink><i class="fa fa-angle-right"></i>{Rating}</NavLink>
                </NavItem>
            </Nav>
        </NavItem>
        <NavItem>
            <NavLink><FeatherIcon icon="file-text"/>
                <span> {Forms}</span>
            </NavLink>
        </NavItem>
        <NavItem>
            <NavLink><FeatherIcon icon="server"/>
                <span> {Tables}</span>
            </NavLink>
        </NavItem>
    </Nav>
  </Col>